<img [src]="src" [class]="styleClass">
